import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=0831c66a&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=0831c66a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0831c66a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0831c66a')) {
      api.createRecord('0831c66a', component.options)
    } else {
      api.reload('0831c66a', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=0831c66a&scoped=true&", function () {
      api.rerender('0831c66a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CiEb1gCe2OFD/JS/teamMember.vue"
export default component.exports